'use client';

import * as React from 'react';

export interface ISidebarContext {
  sidebarOpen: boolean;
  setSidebarState: (state: boolean) => void;
  toggleSidebar: () => void;
  expandedItems: Set<string>; //string[];
  setExpandedItems: (items: Set<string>) => void;
  manuallyToggledItems: React.MutableRefObject<Set<string>>;
  scrollPosition: number;
  setScrollPosition: (scrollPosition: number) => void;
}

export const SidebarContext = React.createContext<ISidebarContext>({
  sidebarOpen: false,
  setSidebarState: () => {},
  toggleSidebar: () => {},
  expandedItems: new Set<string>(), //[],
  setExpandedItems: () => {},
  manuallyToggledItems: { current: new Set<string>() },
  scrollPosition: 0,
  setScrollPosition: () => {},
});

export const SidebarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [expandedItems, setExpandedItems] = React.useState<Set<string>>(new Set<string>());
  const manuallyToggledItems = React.useRef<Set<string>>(new Set<string>());
  const [scrollPosition, setScrollPosition] = React.useState<number>(0);

  const setSidebarState = (state: boolean) => {
    setIsOpen(state);
  };

  const toggleSidebar = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const contextValue = React.useMemo(
    () => ({
      sidebarOpen: isOpen,
      setSidebarState,
      toggleSidebar,
      expandedItems,
      setExpandedItems,
      manuallyToggledItems,
      scrollPosition,
      setScrollPosition,
    }),
    [isOpen, scrollPosition, toggleSidebar, expandedItems],
  );

  return <SidebarContext.Provider value={contextValue}>{children}</SidebarContext.Provider>;
};
